<template>
  <div class="typing-row">
    <v-card
      flat
      class="typing-bubble"
    >
      <v-card-text class="typing-content">
        <span class="dot dot-1" />
        <span class="dot dot-2" />
        <span class="dot dot-3" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TypingIndicator'
}
</script>

<style scoped>
.typing-row {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0;
}

.typing-bubble {
  background: rgba(255, 255, 255, 0.62) !important;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 999px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05) !important;
  backdrop-filter: blur(6px);
}

.typing-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 10px;
}

.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #94a3b8;
  opacity: .22;
  animation: typingPulse 1.2s infinite ease-in-out;
}

.dot-2 {
  animation-delay: .15s;
}

.dot-3 {
  animation-delay: .3s;
}

@keyframes typingPulse {
  0%,
  80%,
  100% {
    transform: translateY(0) scale(.85);
    opacity: .22;
  }

  40% {
    transform: translateY(-4px) scale(1);
    opacity: .72;
  }
}
</style>
